import { render, staticRenderFns } from "./CallDialPad.vue?vue&type=template&id=0b5b9b98&"
import script from "./CallDialPad.vue?vue&type=script&lang=js&"
export * from "./CallDialPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports